// eslint-disable-next-line import/prefer-default-export
export const container = Symbol('container');



// WEBPACK FOOTER //
// ./src/js/util/carousel.js